import React, { useContext, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import styles from './SolutionsGrid.module.css';
import ship from "../../../Assests/Images/sheep.png";
import truck from "../../../Assests/Images/truck.png";
import laptop from "../../../Assests/Images/laptop.png";
import arrow from "../../../Assests/Images/purple Arrow.svg";
import { SelectedCardContext } from "../../../Context/SelectedCardContext";
import whitecrossicon from "../../../Assests/Images/close-normal.svg";
import bluecrossicon from "../../../Assests/Images/close-hover.svg";
 
const SolutionsGrid = () => {
  const { setSelectedCard } = useContext(SelectedCardContext);

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCard, setModalCard] = useState(null);

  // Content for each card type
  const contentMap = {
    "Seamless Global Procurement & Logistics Solutions": {
      title: "From essential consumables to complex machinery, we ensure on-time, on-budget delivery without compromising on quality.",
      items: [
        "Strategic supplier relationships across multiple regions",
        "Full logistics coordination from procurement to delivery",
        "Comprehensive documentation management",
        "Quality assurance at every stage of the supply chain"
      ]
    },
    "Procurement Excellence": {
      title: "At Hyproc International, we simplify procurement and shipping, ensuring efficiency, cost control, and reliability at every stage.",
      items: [
        "Our expertise allows you to focus on your core operations while we manage the complexities of sourcing and logistics",
        "Customized procurement strategies based on industry needs",
        "Digital tracking and transparency throughout the procurement process",
        "Cost optimization without compromising on quality or delivery times"
      ]
    },
    "Global Shipping Expertise": {
      title: "Our specialized shipping solutions ensure your goods arrive safely and on time, anywhere in the world.",
      items: [
        "Optimizing transport based on shipment size, weight, and destination",
        "Managing customs paperwork and Incoterms compliance to prevent delays",
        "Coordinating with a global network of carriers to ensure safe, timely delivery",
        "Specialized handling for sensitive, oversized, or hazardous materials"
      ]
    }
  };

  const procurementData = [
    {
      title: 'Seamless Global Procurement & Logistics Solutions',
      description: 'Streamlined global procurement and logistics services that ensure efficient supply chain operations across international borders.',
      image: truck,
    },
    {
      title: 'Procurement Excellence',
      description: 'Strategic sourcing and procurement expertise that delivers cost-effective solutions while maintaining quality and compliance standards.',
      image: laptop,
    },
    {
      title: 'Global Shipping Expertise',
      description: 'Specialized shipping solutions for complex logistics challenges, ensuring timely delivery of goods to any destination worldwide.',
      image: ship,
    },
  ];

  const handleReadMoreClick = (item) => {
    setModalCard(item);
    setModalOpen(true);
  };

  // Modal component
  const ProcurementModal = ({ open, card, onClose }) => {
    if (!open || !card) return null;
    const content = contentMap[card.title];
    return (
      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
         backgroundColor: "rgba(0, 0, 0, 0.7)",
         padding: "20px",
      }}>
        <div style={{
          background: "#fff",
          borderRadius: "16px",
          maxWidth: "1000px",
          width: "95%",
          padding: "2.2rem 2.2rem 2rem 2.2rem",
          position: "relative",
          boxShadow: "0 4px 24px rgba(0,0,0,0.15)"
        }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 20,
              borderBottom: "2px solid #000064",
              paddingBottom: 15
            }}
          >
            <h2 style={{
              fontWeight: 700,
              fontSize: 28,
              color: "#000064",
              maxWidth: "85%",
              wordWrap: "break-word",
              whiteSpace: "break-spaces",
              margin: 0,
              padding: 0,
              borderBottom: "none"
            }}>{card.title}</h2>
            <button className={styles.closeButton} onClick={onClose}>
              <img 
                src={whitecrossicon} 
                alt="Close" 
                className={styles.closeIconWhite} 
              />
              <img 
                src={bluecrossicon} 
                alt="Close" 
                className={styles.closeIconBlue} 
              />
            </button>
          </div>
          {/* <p style={{
            fontWeight: 400,
            fontSize: 18,
            color: "#000000CC",
            marginBottom: 10,
            position: "relative"
          }}>{card.description}</p> */}
          {content && (
            <>
              <h4 style={{
                fontWeight: 600,
                marginBottom: 10,
                color: "#181c4a",
                fontSize: 18
              }}>{content.title}</h4>
              <ul style={{ paddingLeft: 22, marginBottom: 0 }}>
                {content.items.map((item, idx) => (
                  <li key={idx} style={{
                    marginBottom: 8,
                    color: "#222",
                    fontSize: 18
                  }}>{item}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <ProcurementModal
        open={modalOpen}
        card={modalCard}
        onClose={() => setModalOpen(false)}
      />
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.grid}>
            <div className={styles.leftColumn}>
              {procurementData.slice(0, 2).map((solution, index) => (
                <div key={index} className={styles.card}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={solution.image}
                      alt={solution.title}
                      className={styles.image}
                    />
                  </div>
                  <div className={styles.content}>
                    <h3 className={styles.title}>{solution.title}</h3>
                    <div className={styles.readMoreContainer} onClick={() => handleReadMoreClick(solution)}>
                      <img src={arrow} className={styles.arrowIcon} alt="Arrow icon" />
                      <span className={styles.readmore}>Read More</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
 
            <div className={styles.cardLarge}>
              <div className={styles.largeImageWrapper}>
                <img
                  src={procurementData[2].image}
                  alt={procurementData[2].title}
                  className={styles.image1}
                />
                <div className={styles.content}>
                  <h3 className={styles.title}>{procurementData[2].title}</h3>
                  <div className={styles.readMoreContainer} onClick={() => handleReadMoreClick(procurementData[2])}>
                    <img src={arrow} className={styles.arrowIcon} alt="Arrow icon" />
                    <span className={styles.readmore}>Read More</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
 
export default SolutionsGrid;